const cardStyle = {
  padding: "25px 20px 25px 20px",
  flexDirection: "column",
  justifyContent: "space-between",
  display: "flex",
  fontSize: "14px",
  textAlign: "center",
  maxWidth: "400px",
  // height: "400px",
};

const buttonStyle = {
  backgroundColor: "#556a9f",
  color: "white",
  borderRadius: "4px",
  padding: "8px 16px",
  border: "none",
  cursor: "pointer",
  width: "80px",
};

export const discoverSteps = [
  {
    selector: "#sidenav_0",
    content:
      "Discover new applications! Explore embedded analytics like reports, group reports and different data assets, and other applications.",
    style: cardStyle,
  },
  {
    selector: "#sidenav_1",
    content:
      "Introducing GenAI, your personal assistant! Chat with GenAI to get insights, tips, and assistance with your reports.",
    style: cardStyle,
  },
  {
    selector: "#sidenav_2",
    content:
      "Manage your applications with ease! Register new applications or manage your existing ones in MyApps.",
    style: cardStyle,
  },
  {
    selector: "#sidenav_3",
    content: "Access your saved reports here!",
    style: cardStyle,
  },
  {
    selector: "#sidenav_5",
    content:
      "Contains documentation for the DART application, offering detailed guides and resources.",
    style: cardStyle,
  },
  {
    selector: "#sidenav_6",
    content:
      "Provides answers to common questions about the DART application, helping users quickly find solutions to their queries.",
    style: cardStyle,
  },
  {
    selector: "#sidenav_7",
    content:
      "Raise tickets, provide feedback, and seek assistance, ensuring a smooth experience with DART.",
    style: cardStyle,
  },
  {
    selector: "#explore-search",
    content:
      "Find specific applications quickly within DART, enhancing navigation and usability.",
    style: cardStyle,
  },
  {
    selector: "#explore-groupby",
    content:
      "This is 'Group By' section. Group applications based on selected criteria,",
    style: cardStyle,
  },
  {
    selector: "#explore-viewby",
    content:
      "Change within viewing options here between large tiles, medium tiles with details, and table view, providing versatile ways to interact with DART.",
    style: cardStyle,
  },
  {
    selector: "#explore-filter",
    content:
      "Filter reports, data assets or other applications based on different parameters and save for future use",
    style: cardStyle,
  },
  {
    selector: "#MediumViewCard",
    content:
      "Click on the tile to open the applications details page to deep dive into the metadata for the report or data assets",

    style: cardStyle,
  },
  {
    selector: "end-tour",
    content: (prop) => (
      <>
        <h2>Happy journey!</h2>
      </>
    ),
    style: {
      ...cardStyle,
      maxWidth: "500px",
      width: "400px",
      height: "200px",
    },
  },
];

export const assistSteps = [
  {
    selector: ".searchInAssist1",
    content:
      "The GenAI search conversation lets users find specific chat topics quickly.",

    style: cardStyle,
  },
  {
    selector: "#startNewChatBtn",
    content:
      "Click 'Start New Chat' to begin a new session and ask GenAI your questions.",

    style: cardStyle,
  },
  {
    selector: ".searchInAssist2",
    content:
      "Enter your question and press enter or the adjacent button to begin the conversation.",

    style: cardStyle,
  },
  {
    selector: "end-tour",
    content: (prop) => (
      <>
        <h2>Happy journey!</h2>
      </>
    ),
    style: {
      ...cardStyle,
      maxWidth: "500px",
      width: "400px",
      height: "200px",
    },
  },
];

export const DetailsPageSteps = [
  {
    selector: ".Details_0",
    content:
      "Provides information about the currently opened report or data asset",
    style: cardStyle,
  },
  {
    selector: ".Details_1",
    content:
      "Shows tables related to registered BI reports, providing with an overview of the underlying data structures and relationships within the applications",
    style: cardStyle,
  },
  {
    selector: ".Details_2",
    content:
      "Shows lineage data, showing the flow of data from target applications back to the source data.",
    style: cardStyle,
  },
  {
    selector: ".Details_3",
    content: "You can view your group reports from here.",
    style: cardStyle,
  },

  {
    selector: ".Details_4",
    content: "Provides information about the currently opened application",
    style: cardStyle,
  },
  {
    selector: ".dataset_0",
    content: "Provides information about the currently opened application",
    style: cardStyle,
  },
  {
    selector: ".dataset_1",
    content:
      "Discover comprehensive column definitions section. Understand your data structure at a glance and make the most of your information.",
    style: cardStyle,
  },
  {
    selector: ".dataset_2",
    content:
      "Explore a preview of your data with our sample data section. Get a glimpse of your table's content and layout to better understand your information.",
    style: cardStyle,
  },
  {
    selector: ".dataset_3",
    content:
      "Shows lineage data, showing the flow of data from target applications back to the source data.",
    style: cardStyle,
  },
  {
    selector: "#access-type",
    content:
      "Applications can be public or private. Public applications can be opened by anyone, while private applications require specific access permissions.",
    style: cardStyle,
  },
  {
    selector: "#nested-report-container",
    content:
      "Explore your group reports presented with 1 of 9 unique template, to suit your needs.",
    style: cardStyle,
  },
  {
    selector: "#customized-button",
    content: "Press this button to Explore the registered Data Asset",
    style: cardStyle,
  },
  {
    selector: "#go-to-reportButton",
    content: "Press this button to request-for-access/open the application",
    style: cardStyle,
  },
  {
    selector: "#request-access-button",
    content: "Press this button to request-for-access",
    style: cardStyle,
  },
  {
    selector: "#details-area1",
    content:
      "This section shows application description, Details, Endorsements, Resources and Recommended Applications related to the current application",
    style: cardStyle,
  },
  {
    selector: "#EmbedReportIframe",
    content:
      "Report Section, Dive into your data, gain valuable insights, and take informed actions based on your findings.",
    style: cardStyle,
  },
  {
    selector: "end-tour",
    content: (prop) => (
      <>
        <h2>Happy journey!</h2>
      </>
    ),
    style: {
      ...cardStyle,
      maxWidth: "500px",
      width: "400px",
      height: "200px",
    },
  },
];

export const accountSetupStep1 = [
  {
    selector: "start-tour",
    content: (prop) => (
      <>
        <h2>Welcome!</h2>
        <p>
          We're excited to have you on board. Let's take a quick tour to help
          you get started.
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "50px 40px 0px 40px",
          }}
        >
          <button
            onClick={() => {
              prop.close();
            }}
            style={buttonStyle}
          >
            Skip
          </button>
          <button onClick={() => prop.goTo(1)} style={buttonStyle}>
            Next
          </button>
        </div>
      </>
    ),
    style: { ...cardStyle, maxWidth: "500px", width: "500px", height: "300px" },
  },
  {
    selector: "#journey-begin-button",
    content: "Click here to start your journey",
    style: cardStyle,
  },
];

export const accountSetupStep2 = [
  {
    selector: "#locationContent",
    content: "Select your geographic location and press next",
    style: cardStyle,
  },
];

export const accountSetupStep3 = [
  {
    selector: "#functionContent",
    content: "Select your areas of interest and press next",
    style: cardStyle,
  },
];

export const accountSetupStep4 = [
  {
    selector: "#jobRoleContent",
    content: "Select your Job Role and press next",
    style: cardStyle,
  },
];
